import React from "react";
import { Container } from "react-bootstrap";
import img_about from "../../assets/images/contact/page-about.webp";
import img_email from "../../assets/images/contact/email.webp";
import img_phone from "../../assets/images/contact/phone.webp";
import "./index.css";
import { CONTACT_EMAIL, CONTACT_PHONE_NUMBER } from "../../constant/index";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="about-container">
      <div className="about-content">
        {/* Top Feature Image */}
        <div className="about-header-image">
          <img src={img_about} alt="IKI AI Journey" className="hero-img" />
        </div>

        {/* Page Title */}
        <h1 className="about-title global-title">{t("about_page.title")}</h1>

        {/* Intro Section */}
        <div className="intro-section">
          <h2 className="intro-title global-subtitle">{t("about_page.intro_title")}</h2>
          <p className="intro-description global-subtitle">{t("about_page.intro_des")}</p>
        </div>

        {/* Story Section */}
        <div className="about-section">
          <h3 className="section-label global-subtitle">{t("about_page.story_title")}</h3>
          <div className="section-text global-text">
            <p>{t("about_page.story_p1")}</p>
            <p>{t("about_page.story_p2")}</p>
            <p>{t("about_page.story_p3")}</p>
            <p>{t("about_page.story_p4")}</p>
          </div>
        </div>

        {/* Mission Section */}
        <div className="about-section">
          <h3 className="section-label global-subtitle">{t("about_page.mission_title")}</h3>
          <div className="section-text global-text">
            <p>{t("about_page.mission_p1")}</p>
            <p>{t("about_page.mission_p2")}</p>
            <p className="footer-note">{t("about_page.mission_footer")}</p>
          </div>
        </div>

        {/* Contact info at the bottom */}
        <div className="about-contact-info">
          <div className="contact-item">
            <img src={img_email} alt="Email" />
            <span>{CONTACT_EMAIL}</span>
          </div>
          <div className="contact-item">
            <img src={img_phone} alt="Phone" />
            <span>{CONTACT_PHONE_NUMBER}</span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AboutUs;
